module.exports = __webpack_public_path__ + "static/ux-46f0261596ccf99901c1818ec7555342.png";